
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[oldId]",
      function () {
        return require("private-next-pages/news/[oldId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/[oldId]"])
      });
    }
  